"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataAndDefaultState = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const table_styles_1 = require("../table.styles");
const no_data_strategy_matrix_1 = __importDefault(require("../../../../icons/svg/no-data-strategy-matrix"));
const localization_1 = require("../../../../localization");
const NoDataAndDefaultState = ({ errorMessage, selectedAttribute, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(table_styles_1.NoDataWrapper, null, react_1.default.createElement(no_data_strategy_matrix_1.default, null), !selectedAttribute && (react_1.default.createElement(ui_components_1.Typography, null, t({ key: 'SELECT_ATTRIBUTE_USER' }))), errorMessage && react_1.default.createElement(ui_components_1.Typography, null, t({ key: 'NO_DATA_AVAILABLE' }))));
};
exports.NoDataAndDefaultState = NoDataAndDefaultState;
